module.exports = "<!-- FIXME: Implement\r\n<zxing-scanner [formats]=\"['QR_CODE']\" (scanSuccess)=\"qrlogin($event)\"></zxing-scanner>-->\r\n"